<div class="stackedBarchartWrapper" [style.height.px]="passedHeight">
  <canvas #chartCanvas [class.dimmed]="noDataOnChart"></canvas>
  @if (noDataOnChart) {
    <div class="noDataOverlay secondaryTextColor">
      {{ 'STATISTICS.NO_CHART_DATA' | translate }}
    </div>
  }
</div>
